package com.example.mystybag.core.helpers

import kotlinx.coroutines.CoroutineName
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch
import kotlinx.coroutines.plus

object ScreenCastHelper {

    val displaysFlow     = MutableStateFlow(0)
    val castDisabledFlow = MutableStateFlow(false)

    init {
        (CoroutineScope(Dispatchers.Default) + globalExceptionHandler).launch(CoroutineName("ScreenCastHelper")) {

        }
    }
}